import React from 'react'
import useFooter from './hooks/useFooter'
import './style.scss'

const NewFooter = ({ className = '', style = {} }) => {
  const {
    isAllowHost,
    isNewEventActive,
    isHostedEventActive,
    isPackagesActive,
    handleNewEvent,
    handleHostedEvent,
    handlePackages,
    myEventsCount,
    packagesCount,
    hasPackages,
    BlockPopup,
  } = useFooter()

  if (!isAllowHost) {
    return BlockPopup || null
  }

  return (
    <React.Fragment>
      <div style={{ borderTop: '0.5px solid #e0e0e0', background: 'white' }}>
        <div className={`bottom-bar ${className}`.trim()} style={style}>
        <button
          type='button'
          className={`bottom-btn ${isNewEventActive ? 'active' : ''}`}
          id='btn-hosting'
          onClick={handleNewEvent}
        >
          <svg
            width='20'
            height='20'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.8'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <line x1='12' y1='5' x2='12' y2='19' />
            <line x1='5' y1='12' x2='19' y2='12' />
          </svg>
          <span>New Event</span>
        </button>

        <button
          type='button'
          className={`bottom-btn ${isHostedEventActive ? 'active' : ''}`}
          id='btn-hosted'
          onClick={handleHostedEvent}
        >
          <svg
            width='20'
            height='20'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.8'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <rect x='3' y='4' width='18' height='18' rx='2' />
            <line x1='16' y1='2' x2='16' y2='6' />
            <line x1='8' y1='2' x2='8' y2='6' />
            <line x1='3' y1='10' x2='21' y2='10' />
          </svg>
          <span>
            Hosted Event
            {Boolean(myEventsCount) && (
              <span className='badge-count'>({myEventsCount})</span>
            )}
          </span>
        </button>

        {hasPackages && (
          <button
            type='button'
            className={`bottom-btn ${isPackagesActive ? 'active' : ''}`}
            id='btn-packages'
            onClick={handlePackages}
          >
            <svg
              width='20'
              height='20'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='1.8'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <line x1='16.5' y1='9.4' x2='7.5' y2='4.21' />
              <path d='M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' />
              <polyline points='3.27 6.96 12 12.01 20.73 6.96' />
              <line x1='12' y1='22.08' x2='12' y2='12' />
            </svg>
            <span>
              Packages
              {Boolean(packagesCount) && (
                <span className='badge-count'>({packagesCount})</span>
              )}
            </span>
          </button>
        )}
        </div>
      </div>
      {BlockPopup}
    </React.Fragment>
  )
}

export default NewFooter
